module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAMCAMAAACOacfrAAAANlBMVEUAAAD////////////////////////////////////////////////////////////////////xY8b8AAAAEXRSTlMAKA348uzEvLatm4l2ZFJDNU3S9CkAAABCSURBVAjXYwADRjZGCAECAqyCHBACCPhZBNmZwASQw8csyMkEIkAcXkFBLggBBDyCgtwQAp2HphLVFFQbMG1HuAwAU68ECRNB08gAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_fold_hover.png
// module id = Zroz
// module chunks = 9